import { ApiResponseInterceptors } from "@/app/api";
import { ReactNode, useContext, useEffect, useRef } from "react"
import { KeycloakContext } from "@/app/providers/KeycloakProvider";
import Loader from "atol-atoms-2/Loader";
import { authMe } from "@/api/apiAccessPoint";
import styles from './styles.module.scss'

interface FrontolCodeTrackerProviderProps {
    children: ReactNode;
}

const headerName = 'x-token-refresh'

function* infinite(delay: number = 0, abort: AbortController) {
    let isAborted = false
    abort.signal.addEventListener('abort', () => isAborted = true)
    while (true) {
        if (isAborted) break
        yield new Promise(resolve => setTimeout(resolve, delay))
    }
}

export const FrontolCodeTrackerProvider = ({ children }: FrontolCodeTrackerProviderProps) => {
    const { tokenParsed } = useContext(KeycloakContext)
    const canCheckHeadersRef = useRef(!tokenParsed?.frontol_code)
    const abortControllerRef = useRef(new AbortController())

    const makeInfinitReqeusts = async () => {
        for await (const _ of infinite(1000, abortControllerRef.current)) await authMe() // Ожидаем x-token-refresh в ответе
    }

    useEffect(() => {
        if (canCheckHeadersRef.current && !ApiResponseInterceptors.has(headerName)) {
            ApiResponseInterceptors.set(headerName, async (response) => {
                if (canCheckHeadersRef.current && Array.from(response.headers.keys()).includes(headerName)) {
                    abortControllerRef.current.abort()
                    window.location.reload()
                }
                return response
            });

            makeInfinitReqeusts()
        }
    }, [])

    return canCheckHeadersRef.current ? <Loader size={64} className={styles.loader} /> : children
}